<template>
  <v-dialog
    v-model="model"
    :width="$vuetify.breakpoint.mdAndUp ? '300px' : ''"
  >
    <v-card>
      <v-card-title class="pa-0 mb-3">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title
            class="accent--text headline"
          >
            Select organization
          </v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-list>
          <template v-for="(tenant, tIdx) in getMyTenants">
            <v-list-item
              @click="doChangeSession(tenant.id)"
              :key="`tenant_${tIdx}`"
            >
              <v-list-item-title>{{ tenant.label }}</v-list-item-title>
            </v-list-item>
            <v-divider v-if="tIdx + 1 !== getMyTenants.length" />
          </template>
        </v-list>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([ 'getAuthUser', 'getSessionDialog', 'getMyTenants' ]),
    model: {
      get() {
        return this.getSessionDialog
      },
      set(val) {
        this.setSessionDialog(val)
      }
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions([ 'setSessionDialog', 'changeSession' ]),
    doChangeSession(id) {
      this.changeSession(id)
      this.model = false
    }
  }
}
</script>
